import { Box, Typography } from '@mui/material';
import { useAuth } from '../../auth/auth-hook';
import { Plan } from '../../../shared/types/generated';
import { getPostUrl, getUrlCoupon } from '../../auth/auth-utils';
import { triggerEvent } from '../../remote-education/remote-education-utils';

export const SubscribeButtonMobile: React.FC<{
  plan: Plan;
  backgroudColor: string;
  event?: string;
}> = ({ plan, backgroudColor, event }) => {
  const { user } = useAuth();
  return (
    <Box
      component={'div'}
      role="button"
      tabIndex={0}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      style={{ background: backgroudColor, cursor: 'pointer' }}
      flex={1}
      borderRadius={'5px'}
      height={{ xs: '40px', md: '45px' }}
      onClick={() => {
        if (event) triggerEvent(event);
        if (user)
          return (window.location.href = `/metodos-de-pago/${
            plan.slug
          }?post_url=${getPostUrl()}&coupon=${getUrlCoupon()}`);
        else {
          const redirectUrl = `${window.location.origin}/metodos-de-pago/${
            plan.slug
          }?post_url=${getPostUrl()}&coupon=${getUrlCoupon()}`;
          window.location.href = `${
            window.location.origin
          }/autenticacion?redirect_url=${encodeURIComponent(redirectUrl)}`;
        }
      }}
    >
      <Typography
        fontFamily={'oswald'}
        fontSize={{ xs: '18px' }}
        lineHeight={{ xs: '22px' }}
        color={'#ffffff'}
        fontWeight={400}
        textAlign={'center'}
        textTransform={'uppercase'}
        paddingTop={'2px'}
      >
        Suscríbete
      </Typography>
    </Box>
  );
};
